'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-dom-test-utils.production.min.js');
} else {
  module.exports = require('./cjs/react-dom-test-utils.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/test-utils.js
// module id = 4391
// module chunks = 168707334958949